<template>
  <section class="yield-right-panel result-gauge-panel">
    <div class="right-section-title">预测结果</div>
    <div ref="chartRef" class="gauge-chart"></div>
    <div class="result-meta">
      <div class="result-meta-item">
        <span class="meta-icon">↕</span>
        <p>预计增产区间</p>
        <strong>3.2%--5.6%</strong>
      </div>
      <div class="result-meta-item">
        <span class="meta-icon">✓</span>
        <p>预测置信度</p>
        <strong>89.6%</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const chartRef = ref(null);
let chartInstance = null;

function resizeChart() {
  chartInstance && chartInstance.resize();
}

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    series: [
      {
        type: "gauge",
        radius: "92%",
        center: ["50%", "54%"],
        startAngle: 220,
        endAngle: -40,
        min: 0,
        max: 100,
        splitNumber: 10,
        axisLine: {
          lineStyle: {
            width: 20,
            color: [
              [0.12, "#ffd33e"],
              [0.896, "#21f6df"],
              [1, "rgba(41,255,229,0.16)"],
            ],
          },
        },
        progress: {
          show: true,
          roundCap: true,
          width: 20,
          itemStyle: {
            color: "#21f6df",
            shadowBlur: 18,
            shadowColor: "rgba(33,246,223,.55)",
          },
        },
        axisTick: {
          distance: -34,
          length: 8,
          splitNumber: 5,
          lineStyle: { color: "rgba(133,255,242,.38)", width: 2 },
        },
        splitLine: {
          distance: -38,
          length: 18,
          lineStyle: { color: "rgba(133,255,242,.44)", width: 3 },
        },
        axisLabel: { show: false },
        pointer: { show: false },
        anchor: { show: false },
        title: {
          offsetCenter: [0, "-24%"],
          color: "#ffffff",
          fontSize: 30,
          fontWeight: 700,
        },
        detail: {
          valueAnimation: true,
          offsetCenter: [0, "18%"],
          color: "#ffffff",
          fontSize: 76,
          fontWeight: 800,
          formatter: "{value}",
        },
        data: [{ value: 89.6, name: "综合产量指数" }],
      },
    ],
  });
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
@import "../YieldRightShared.less";

.result-gauge-panel {
  height: 100%;
  padding: 26px 36px 28px;
}

.gauge-chart {
  width: 100%;
  height: calc(100% - 168px);
  min-height: 280px;
  margin-top: 6px;
}

.result-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 34px;
}

.result-meta-item {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  grid-template-rows: auto auto;
  align-items: center;
  column-gap: 14px;
  color: #ffffff;
  text-align: left;
}

.meta-icon {
  grid-row: 1 / span 2;
  width: 52px;
  height: 52px;
  border: 2px solid rgba(42, 255, 232, 0.75);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4effee;
  font-size: 30px;
  font-weight: 800;
  background: radial-gradient(circle, rgba(0, 116, 105, 0.88), rgba(0, 54, 50, 0.92));
  box-shadow: 0 0 16px rgba(42, 255, 232, 0.28);
}

p {
  margin: 0;
  color: #dffefa;
  font-size: 30px;
  font-weight: 700;
  line-height: 46px;
}

strong {
  color: #ffffff;
  font-size: 32px;
  font-weight: 800;
  line-height: 40px;
  white-space: nowrap;
}
</style>
